<h6>Signature:</h6>
<div>
	<canvas
		#canvas
		[ngClass]="isSignatureMissingError ? 'error-border' : ''"
		(touchstart)="startDrawing($event)"
		(touchmove)="moved($event)"
		[width]="!isMobileView ? 700 : 300"
		[height]="!isMobileView ? 200 : 150">
	</canvas>
	<p class="error-message" *ngIf="isSignatureMissingError">Signature is required</p>
</div>

<div class="buttons flex justify-between mt-2">
	<a class="link mr-4 py-2" (click)="clearPad()"><span>Clear</span></a>
	<button class="button" mat-button [disabled]="isSubmitDisabled" (click)="savePad()">Accept the signature</button>
</div>
